var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ml-3",attrs:{"color":"teal","small":"","dark":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-account ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }